import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
// import { BotonPrincipal } from './btnPrincipal';
import { Button } from 'antd';
import { BotonPrincipal } from './btnPrincipal';
import { ModalApp } from './modalApp';

export const ContainerAdministracion = ({
  link, 
  texto, 
  img,
  textoInfo,
  descripcion,
  ancho,
  inscriptos,
  modalAbrir
}) => {
  // console.log("ins", inscriptos)
  const [modal, setModal] = useState(false);
  return (
    <>
      <div
        style={{
          border: "1px solid #bbbbbb",
          borderRadius: "10px",
          padding: "30px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          width: "18em",
          height: "20em",
          gap: 10,
          textAlign: "center",
        }}
      >
        <Link
          to={link}
          style={{ fontSize: 16 }}
        >
          <div
            translate="no" 
            className="notranslate"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 40
            }}
            > 
            {/*  || <span style={{ color: "transparent" }}>span</span>} */}
              <p style={{color:"#BA1721", fontSize: 16}}>{textoInfo}</p>
              {inscriptos !== undefined ? (
                <div style={{ 
                  display: "flex", 
                  justifyContent: "center", 
                  alignItems:"center", 
                  width: 25, 
                  height: 25, 
                  borderRadius: 360, 
                  backgroundColor: "#BA1721", 
                  color: "#fff" 
                }}>
                  <p>{inscriptos}</p>
                </div>
              ) : ""}
              <div 
                style={{ 
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 10
                }}
              >
                <img 
                  src={`/img/administracion/${img}`}
                  alt='administracion'
                  style={{ width: ancho ? "auto": 100, height: 100 }}
                />
                
                <p style={{color:"#BA1721",border:"none",padding:"0.5m", fontSize: 22}}>{texto}</p>
                <p style={{color:"#000", fontSize: 14}}>{descripcion}</p>
              </div>
            </div>
        </Link>
        {modalAbrir !== undefined && (
          <BotonPrincipal type="primary" texto={"Abrir gestor"} onClick={() => setModal(true)}/>
        )}
      </div>
      {modal && (
        <ModalApp 
          open={modal}
          onCancel={() => setModal(false)}
        />
      )}
    </>

  );
}